<div class="product__header main-header-prod d-flex jc-space-between px-tiny py-xsmall">
        <lib-cc-header
        [showLogin]="true"
        [showLinks]="true"
        [transparentBackground]="true"
        [transparentScroll]="true"
        [ccEnvironment]="ccEnvironment"
        (openLoginModalEvent)="OpenOnboardingModal($event)"
      >
      <icon-shopping-car class="secondary-nav ai-center d-flex" aria-label="header-menu-secondary">
        <button class="secondary-nav__shopping " (click)="openShoppingDialog() " name="shopping dialog " type="button ">
            <span class="icon material-icons text-secondary-base bg-secondary-base-9 ">shopping_cart</span>
            <span class="badge badge-bottom-left ">{{count}}</span>
        </button>
    </icon-shopping-car>
    </lib-cc-header>
</div>